import './EllipsisTooltip.scss';

import { ToolTip } from '@travelwin/core';
import { PropsWithChildren, useEffect, useRef, useState } from 'react';

interface EllipsisTooltipProps extends PropsWithChildren {
  maxWidth: string;
  popupInnerText?: string;
}

const EllipsisTooltip = ({
  children,
  maxWidth,
  popupInnerText = '',
}: EllipsisTooltipProps) => {
  const className = 'c-EllipsisTooltip';

  const [isEllipsis, setIsEllipsis] = useState(false);
  const ellipsisContent = useRef<HTMLDivElement>(null);

  const renderText = (
    <span ref={ellipsisContent} className={`${className}__ellipsis`}>
      {children}
    </span>
  );

  useEffect(() => {
    if (ellipsisContent.current) {
      setIsEllipsis(
        ellipsisContent.current.scrollWidth >
          ellipsisContent.current.clientWidth,
      );
    }
  }, [ellipsisContent]);

  return (
    <div className={className} style={{ maxWidth }}>
      {isEllipsis ? (
        <ToolTip content={popupInnerText} position="right">
          {renderText}
        </ToolTip>
      ) : (
        renderText
      )}
    </div>
  );
};

export default EllipsisTooltip;
